export default __webpack_public_path__ + "intake_diagnosis_report.png";